import Dialog from "@material-ui/core/Dialog";
import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

import { colors } from "../../design";
import { IUser } from "../../interfaces";

import Icon from "../atoms/Icon";
import Img from "../atoms/Image";
import Text from "../atoms/Text";

interface IProps {
  user: IUser | null;
  close: () => void;
}

const UserProfileModal: React.FC<IProps> = ({ user, close, ...props }) => {
  const open = user !== null;
  return (
    <Dialog onClose={close} open={open} {...props}>
      {user ? (
        <ModalInner>
          <ProfileAlign>
            <ProfileImg src={user.pictureUrl} />
            <ProfileText>
              {user.displayName}
              <EditLink to={`users/${user.id}/edit`}>
                <PenIcon className="fas fa-pencil" />
              </EditLink>
            </ProfileText>
          </ProfileAlign>
          <TalkButton>
            <MessageLink to={`users/${user.id}/messages`}>
              <IconAlign>
                <TalkIcon className="fas fa-comment-lines" />
                <Text>トーク</Text>
              </IconAlign>
            </MessageLink>
          </TalkButton>
        </ModalInner>
      ) : (
        <div></div>
      )}
    </Dialog>
  );
};

export default UserProfileModal;

const PenIcon = styled(Icon)`
  color: ${colors.lightGray};
  font-size: 0.8rem;
  margin-left: 4px;
`;
const TalkIcon = styled(Icon)`
  font-size: 1.8rem;
  margin-bottom: 4px;
`;
const ProfileImg = styled(Img)`
  width: 100px;
  height: 100px;
  border-radius: 5px;
  object-fit: contain;
  margin-bottom: 12px;
`;

const ProfileText = styled(Text)`
  color: ${colors.lightGray};
  font-size: 0.8rem;
  margin-left: 4px;
`;

const EditLink = styled(Link)``;

const MessageLink = styled(Link)`
  color: ${colors.darkGray};
  border-top: 1px solid ${colors.lightGray};
  display: block;
  padding: 10px 0px;
`;

const ModalInner = styled.div`
  width: 260px;
  text-align: center;
`;
const ProfileAlign = styled.div`
  padding: 20px 0;
`;
const IconAlign = styled.div``;
const TalkButton = styled.div``;
